import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { useReassess } from "./reassess.hook";
import { HeaderComponent } from "../../../../components/header/header.component";

export const ReassessPage: React.FC = () => {
  const { t } = useTranslation();

  // custom-hook
  const { goBack, surveyUI } = useReassess();

  return (
    <React.Fragment>
      <div className="flex flex-col w-full min-h-screen overflow-x-hidden">
        <HeaderComponent title={t("Common.reassess")} onBack={goBack} />
        {surveyUI}
      </div>
    </React.Fragment>
  );
};
